import "/home/runner/work/pocket-dimension-dice/pocket-dimension-dice/components/SettingsModal/styles.module_built.css";
const classes = {"horizontalUl":"-3NNHG_horizontalUl","slider":"-3NNHG_slider","particleEffectsContainer":"-3NNHG_particleEffectsContainer","modalHeading":"-3NNHG_modalHeading","ul":"-3NNHG_ul","radioLabel":"-3NNHG_radioLabel","sliderWrapper":"-3NNHG_sliderWrapper","radio":"-3NNHG_radio","modalH2":"-3NNHG_modalH2","modal":"-3NNHG_modal","modalSection":"-3NNHG_modalSection","modalHeader":"-3NNHG_modalHeader","optionText":"-3NNHG_optionText","volume":"-3NNHG_volume","li":"-3NNHG_li","optionDescription":"-3NNHG_optionDescription"}
export default classes

const _horizontalUl0 = classes["horizontalUl"]
export { _horizontalUl0 as "horizontalUl" }

const _slider0 = classes["slider"]
export { _slider0 as "slider" }

const _particleEffectsContainer0 = classes["particleEffectsContainer"]
export { _particleEffectsContainer0 as "particleEffectsContainer" }

const _modalHeading0 = classes["modalHeading"]
export { _modalHeading0 as "modalHeading" }

const _ul0 = classes["ul"]
export { _ul0 as "ul" }

const _radioLabel0 = classes["radioLabel"]
export { _radioLabel0 as "radioLabel" }

const _sliderWrapper0 = classes["sliderWrapper"]
export { _sliderWrapper0 as "sliderWrapper" }

const _radio0 = classes["radio"]
export { _radio0 as "radio" }

const _modalH20 = classes["modalH2"]
export { _modalH20 as "modalH2" }

const _modal0 = classes["modal"]
export { _modal0 as "modal" }

const _modalSection0 = classes["modalSection"]
export { _modalSection0 as "modalSection" }

const _modalHeader0 = classes["modalHeader"]
export { _modalHeader0 as "modalHeader" }

const _optionText0 = classes["optionText"]
export { _optionText0 as "optionText" }

const _volume0 = classes["volume"]
export { _volume0 as "volume" }

const _li0 = classes["li"]
export { _li0 as "li" }

const _optionDescription0 = classes["optionDescription"]
export { _optionDescription0 as "optionDescription" }
